import { css, fillOutlined, circle, roundedPoly, shade } from './draw-utils';
import type { ProceduralDef } from '../types';

const STONE = 0x6b7280; // fortress steel-stone

/**
 * Bastion — a squat fortress keep with a central eye. The rotating
 * shield arc is drawn in code (boss-side). docs/02 boss pool.
 */
export const bossBastionBody: ProceduralDef = {
  key: 'boss/bastion/body',
  width: 150,
  height: 150,
  anchorX: 0.5,
  anchorY: 0.5,
  frames: 1,
  draw(ctx, w, h) {
    const c = w / 2;
    // Octagonal keep
    const pts: Array<[number, number]> = [];
    for (let i = 0; i < 8; i++) {
      const a = (Math.PI * 2 * i) / 8 + Math.PI / 8;
      pts.push([c + Math.cos(a) * 46, c + Math.sin(a) * 46]);
    }
    roundedPoly(ctx, pts, 8);
    fillOutlined(ctx, STONE, 6);

    // Battlement ring
    circle(ctx, c, c, 34);
    fillOutlined(ctx, shade(STONE, 0.78), 4);

    // Crenellation studs
    ctx.fillStyle = css(shade(STONE, 0.6));
    for (let i = 0; i < 8; i++) {
      const a = (Math.PI * 2 * i) / 8;
      circle(ctx, c + Math.cos(a) * 40, c + Math.sin(a) * 40, 4);
      ctx.fill();
    }

    // Core eye
    circle(ctx, c, c, 18);
    fillOutlined(ctx, 0x1a1430, 4);
    circle(ctx, c, c, 9);
    ctx.fillStyle = css(0xe85a3a);
    ctx.fill();
    circle(ctx, c - 3, c - 3, 3);
    ctx.fillStyle = 'rgba(255,220,200,0.9)';
    ctx.fill();
    void h;
  },
};
